export default "__VITE_ASSET__bf07f670__"